import React, { Component } from "react";
import { connect } from "react-redux";
import { Accordion, Table, Segment, Grid } from "semantic-ui-react";
import _ from "lodash";
import getPrintCaseHeader from "../PrintCaseHeader";
import ReportSummary from "../ReportSummary";
import VehicleDetails from "../VehicleDetails";

class VehicleDppaReport extends Component {
  state = {
    activeIndex: 0,
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
    }
  }

  onReportIndexChanged = (currentIndex) => {
    this.setState({
      activeIndex: currentIndex,
    });
    const element = document.getElementById(`acc_row_${currentIndex}`);
    element.scrollIntoView();
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const rows = [];
    const itemTitles = [];
    let recordCount = 0;
    if (this.props.reportData !== undefined) {
      const records = _.get(
        this.props.reportData,
        "vehicle.vehicleReport[0].record"
      );
      if (records !== undefined) {
        recordCount = records.length;
        _.forEach(records, (record, index) => {
          const name = `${_.get(
            record,
            "vehicleInfo[0].yearMake[0]._"
          )} ${_.get(record, "vehicleInfo[0].make[0]._")} ${_.get(
            record,
            "vehicleInfo[0].model[0]._"
          )}`;
          itemTitles.push(name);
          rows.push(
            <VehicleDetails
              key={`report_acc_title_${index}`}
              record={record}
              detailIndex={index}
              {...this.props}
            />
          );
        });
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>{getPrintCaseHeader(this.props)}</Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                itemTitles={itemTitles}
                activeSummaryIndex={this.state.activeIndex}
                title={`Vehicles Included: ${recordCount}`}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              <Accordion fluid styled>
                {rows}
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(VehicleDppaReport);



// WEBPACK FOOTER //
// ./src/components/reports/Vehicles/VehicleDppaReport.js